import { GetUserDetailsResponse } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { PersonsV3 } from '@frontend/api-person';
import { i18next } from '@frontend/i18n';
import { getFullName } from '@frontend/name';
import { formatPhoneNumber } from '@frontend/phone-numbers';

export const isValidSourceId = (sourceId?: string) => {
  if (!sourceId) return false;
  else if (sourceId === '00000000-0000-0000-0000-000000000000') return false;
  return true;
};

export const getCitationTitle = ({
  patient,
  user,
  phone,
}: {
  patient: Person | null;
  user: GetUserDetailsResponse | undefined;
  phone: string | undefined;
}) => {
  if (patient) {
    return PersonsV3.PersonHelpers.getFullName(patient);
  } else if (user) {
    return getFullName(user);
  } else if (phone) {
    return formatPhoneNumber(phone);
  }
  return i18next.t('Unknown User', { ns: 'task-center' });
};

export const getPersonName = (patient: Person | null, sender: GetUserDetailsResponse | undefined): string => {
  if (patient) {
    return PersonsV3.PersonHelpers.getFullName(patient);
  } else if (sender) {
    return `${sender.firstName ?? ''} ${sender.lastName ?? ''}`.trim();
  }
  return i18next.t('Unknown User', { ns: 'task-center' });
};
